import { useState, useEffect } from 'react'
import { settingsAPI } from '../../services/api'

import { logger } from '@/utils/logger';
export default function FooterSettings() {
  const [settings, setSettings] = useState([])
  const [loading, setLoading] = useState(true)
  const [saving, setSaving] = useState(null)
  const [success, setSuccess] = useState('')
  const [error, setError] = useState('')

  useEffect(() => {
    loadSettings()
  }, [])

  const loadSettings = async () => {
    setLoading(true)
    try {
      const response = await settingsAPI.getAll()
      // Filter nur Footer-Settings
      const footerSettings = response.data.filter(s => s.key.startsWith('footer_'))
      setSettings(footerSettings)
    } catch (err) {
      setError('Fehler beim Laden der Einstellungen')
      logger.error('Error loading settings:', err)
    } finally {
      setLoading(false)
    }
  }

  const handleChange = (key, value) => {
    setSettings(settings.map(s =>
      s.key === key ? { ...s, value } : s
    ))
  }

  const handleSaveAll = async () => {
    setSaving('all')
    setError('')
    setSuccess('')

    try {
      // Alle Footer-Settings speichern
      await Promise.all(
        settings.map(setting => settingsAPI.update(setting.key, setting.value))
      )

      setSuccess('Footer-Einstellungen wurden gespeichert')
      setTimeout(() => setSuccess(''), 3000)
    } catch (err) {
      setError('Fehler beim Speichern der Footer-Einstellungen')
      logger.error('Error saving footer settings:', err)
    } finally {
      setSaving(null)
    }
  }

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: '60px 0' }}>
        <div className="wc-spinner" />
      </div>
    )
  }

  return (
    <div>
      {error && <div className="wc-alert wc-alert-error" style={{ marginBottom: 16 }}>{error}</div>}
      {success && <div className="wc-alert wc-alert-success" style={{ marginBottom: 16 }}>{success}</div>}

      <div className="wc-card wc-elev-sm" style={{ gap: 20, maxWidth: 640 }}>
        <div>
          <h3 className="wc-card-title" style={{ margin: 0 }}>Footer-Einstellungen</h3>
          <p className="wc-muted" style={{ fontSize: 13, margin: '6px 0 0' }}>
            Diese Einstellungen werden im Footer der Website angezeigt und sind für alle Besucher sichtbar.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="wc-field">
            <label>{settings.find(s => s.key === 'footer_company_name')?.description || 'Firmenname im Footer'}</label>
            <input
              type="text"
              value={settings.find(s => s.key === 'footer_company_name')?.value || ''}
              onChange={(e) => handleChange('footer_company_name', e.target.value)}
              className="wc-input"
              placeholder="Werkstatt-Connect"
            />
          </div>

          <div className="wc-field">
            <label>{settings.find(s => s.key === 'footer_company_description')?.description || 'Firmenbeschreibung im Footer'}</label>
            <textarea
              value={settings.find(s => s.key === 'footer_company_description')?.value || ''}
              onChange={(e) => handleChange('footer_company_description', e.target.value)}
              rows={3}
              className="wc-input"
              placeholder="Ihre professionelle Lösung für digitale Werkstatt-Verwaltung"
            />
          </div>

          <div className="wc-field">
            <label>{settings.find(s => s.key === 'footer_contact_email')?.description || 'Kontakt E-Mail im Footer'}</label>
            <input
              type="email"
              value={settings.find(s => s.key === 'footer_contact_email')?.value || ''}
              onChange={(e) => handleChange('footer_contact_email', e.target.value)}
              className="wc-input"
              placeholder="info@werkstatt-connect.de"
            />
          </div>

          <div className="wc-field">
            <label>{settings.find(s => s.key === 'footer_contact_phone')?.description || 'Kontakt Telefon im Footer'}</label>
            <input
              type="tel"
              value={settings.find(s => s.key === 'footer_contact_phone')?.value || ''}
              onChange={(e) => handleChange('footer_contact_phone', e.target.value)}
              className="wc-input"
              placeholder="+49 (0) 123 456789"
            />
          </div>

          <div className="wc-field">
            <label>{settings.find(s => s.key === 'footer_copyright')?.description || 'Copyright-Text im Footer'}</label>
            <input
              type="text"
              value={settings.find(s => s.key === 'footer_copyright')?.value || ''}
              onChange={(e) => handleChange('footer_copyright', e.target.value)}
              className="wc-input"
              placeholder="Werkstatt-Connect. Alle Rechte vorbehalten."
            />
          </div>

          <div style={{ paddingTop: 4 }}>
            <button onClick={handleSaveAll} disabled={saving === 'all'} className="wc-btn wc-btn-primary wc-btn-block">
              {saving === 'all' ? 'Speichern...' : 'Footer-Einstellungen speichern'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
